<template>
  <!-- <div :class="!$mobile ? 'profile--vertical' : 'profile--horizontal'"> -->
  <div class="profile--vertical">
    <div class="profile__thum--relative">
      <!-- https://kprofiles.com/wp-content/uploads/2018/03/2gt2dkMW_400x400.jpg -->
      <div
        v-if="tempFile"
        class="w--80px h--80px bg radius--round"
        :style="`background-image:url(${tempFile});`"
      ></div>
      <!-- <div
          v-if="tempFile"
          :style="`background-image:url(${tempFile});`"
          class="profile__thum"
        ></div> -->

      <avatar
        v-else-if="userId"
        class="profile__thum bg"
        :userId="userId"
      />

      <input
        type="file"
        class="w--80px h--80px opacity--0 position--absolute left--0px top--0px z--50 cursor--pointer"
        @change="handleFileAdd($event)"
        :accept="'.png,.jpeg,.jpg,.gif,.svg'"
      >
      <!-- <div class="profile__upload">
        <div class="form-file__thum">
          <input
            type="file"
            class="form-file__input"
            @change="handleFileAdd($event)"
          >
          <label class="form-file__icon">
            <i class="material-icons">
              add
            </i>
          </label>
        </div>
      </div> -->
    </div>
    <div class="position--relative">
      <div class="profile__content">
        <strong class="profile__id">{{userId}}</strong>
        <span class="label label--xs label--border">{{role | role}}</span>
        <div>
          <p class="profile__name">{{userName}}</p>
          <p class="profile__email">{{email}}</p>
        </div>
      </div>
      <a
        v-if="$utils.getLevel(role) < $utils.getLevel('master1')"
        @click="withdrawal"
        class="position--absolute top--54px right--0px text--gray"
      >회원탈퇴</a>
    </div>
  </div><!-- profile--vertical -->
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    userId: { type: String, required: true, default: '' },
    userName: { type: String, required: true, default: '' },
    email: { type: String, required: true, default: '' },
    role: { type: String, required: true, default: '' },
    error: { type: Object }
    // name: { type: String, required: true },
  },
  computed: {
    ...mapState(['user'])
  },
  data () {
    return {
      fileStatus: '',
      tempFile: null
    }
  },
  methods: {
    async fileUpload (file, config) {
      var formData = new FormData()
      formData.append('file', file)
      const url = `/api/users/avatar`
      const res = await this.$http.post(url, formData, config)
      console.log('res', res)
      return res
    },
    async handleFileAdd (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      this.fileStatus = ''
      const config = {
        onUploadProgress: progressEvent => {
          this.fileStatus = `업로드 중: ${Math.round((progressEvent.loaded * 100) / progressEvent.total)}%`
        }
      }

      try {
        const { data } = await this.fileUpload(files[0], config)
        this.tempFile = URL.createObjectURL(files[0])

        // this.row.files = []
        this.$emit('input', data.fileName)
      } catch (ex) {
        console.error(ex, ex.response)
      } finally {
        this.fileStatus = ''
      }
    },
    async withdrawal () {
      const ret = confirm('정말 회원 탈퇴하시겠습니까?')
      if (!ret) {
        return
      }
      try {
        await this.$http.delete('/api/auth/withdrawal')
        this.$store.commit('SET_USER_INFO', {})
        this.$router.push({ name: 'withdrawal' })
      } catch (ex) {
        console.log(ex)
        alert('문제가 발생하였습니다.')
      }
    }
  },
  components: {
    Avatar: () => import('@/component/common/Avatar')
  }
}
</script>
